import { Box, Skeleton, Stack } from '@redbubble/design-system';
import Field from '@redbubble/design-system/dist/Form/Field';
import { useMemo } from 'react';
import { LoadingBoundary } from '../../LoadingBoundary';
import { compareDisplayOrder } from '../utils';
import type { ColorOption, CommonAttributeConfiguratorProps } from './types';

export type ColorFieldConfiguratorProps = {
  options: Array<ColorOption>;
} & CommonAttributeConfiguratorProps;

const ColorFieldSkeleton = () => {
  return (
    <Box marginLeft="xs" marginRight="xs" marginBottom="l">
      <Stack spacing="xs">
        <Skeleton height={26} width={130} animated roundedCorners />
        <Skeleton height={44} animated roundedCorners />
      </Stack>
    </Box>
  );
};

export const ColorFieldConfigurator: React.FC<ColorFieldConfiguratorProps> = ({
  label,
  attributeName,
  currentValue,
  options,
  actionSlot,
}) => {
  const valueSubtitle = options.find(
    (a) => a.value === currentValue
  )?.defaultText;

  const sortedOptions = useMemo(
    () =>
      options.toSorted(compareDisplayOrder).map((option) => ({
        ...option,
        label: option.defaultText,
        imageUrl: option.media,
      })),
    [options]
  );

  return (
    <LoadingBoundary loadingComponent={<ColorFieldSkeleton />}>
      <Field
        label={label}
        fluid
        type="color"
        showTick
        labelSubtitle={valueSubtitle}
        multiple={false}
        name={attributeName}
        value={currentValue}
        options={sortedOptions}
        actionSlot={actionSlot}
      />
    </LoadingBoundary>
  );
};
